import Props from './interfaces'
import * as Styled from './styled'
import Spinner from '../../svgs/Spinner'
import { MouseEvent } from 'react'

function Button({
  onClick,
  children,
  disabled,
  color,
  width,
  height,
  loading,
  ...rest
}: Props) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (loading) event.preventDefault()
    onClick?.(event)
  }

  return (
    <Styled.Button
      onClick={handleClick}
      disabled={disabled}
      $color={color}
      $width={width}
      $height={height}
      {...rest}
    >
      {loading ? <Spinner /> : children}
    </Styled.Button>
  )
}

Button.defaultProps = { color: 'primary', disabled: false, height: 48, type: 'button' }

export default Button
